import httpClient from "@/store/httpClient";

export default {
    namespaced: true,
    state: {
        events: []
    },
    mutations: {
        SET_EVENTS(state, events) {
            state.events = events;
        }
    },
    actions: {
        async loadEvents({ commit }) {
            const events = await httpClient.get("/veranstaltung/forUser");

            if(events.status === 200) {
                commit("SET_EVENTS", events.data);
            }
        },
        async signUpForEvent({ dispatch }, {eventId, message}) {
            const response = await httpClient.post(`/veranstaltung/sign-up?id=${eventId}`, { message });
            if(response.status === 200) {
                await dispatch("loadEvents");
            }
        },
        async suggestEvent(_, message) {
            const response = await httpClient.post("/veranstaltung/suggest", {
                message
            });

            return response.status === 200;
        }
    },
    getters: {
        upcomingEvents: state => state.events
            .filter(event => !event.SortKey || event.SortKey > new Date().getTime())
            .sort((a, b) => {
                if(!a.SortKey && !b.SortKey) {
                    return 0;
                }
                if(!a.SortKey) {
                    return 1;
                }
                if(!b.SortKey) {
                    return -1;
                }
                return a.SortKey - b.SortKey;
            }),
        pastEvents: state => state.events.filter(event => event.SortKey && event.SortKey < new Date().getTime()),
        eventById: state => eventId => state.events.find(event => event.id === eventId),
    }
}